module.exports = __webpack_public_path__ + "img/donacion.43e6cd01.png";